import { Button } from "./button";
import { Input, Select, Textarea, FormLabel, Form, FormError } from "./input";
import { Table } from "./table";
import { Badge } from "./badge";
import { Card } from "./card";
import { Modal } from "./modal";
import { Drawer } from "./drawer";
import { Popover } from "./popover";
import { Menu } from "./menu";
import { Tooltip } from "./tooltip";
import { Stepper } from "./stepper";
import { Alert } from "./alert";
import { Tabs } from "./tabs";
import { Checkbox } from "./checkbox";
import { Radio } from "./radio";
import { Switch } from "./switch";
import { Skeleton } from "./skeleton";
import { Heading } from "./heading";
import { Divider } from "./divider";
import { Spinner } from "./spinner";
import { Breadcrumb } from "./breadcrumb";

export const components = {
  Button,
  Input,
  Select,
  Textarea,
  FormLabel,
  Form,
  FormError,
  Table,
  Badge,
  Card,
  Modal,
  Drawer,
  Popover,
  Menu,
  Tooltip,
  Stepper,
  Alert,
  Tabs,
  Checkbox,
  Radio,
  Switch,
  Skeleton,
  Heading,
  Divider,
  Spinner,
  Breadcrumb,
};
